module.exports = __webpack_public_path__ + "img/19.4575dcc0.png";